import React, { useState } from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import LoginLoaderButton from "../../Common/Loader/LoginLoaderButton";
import { addCalender, deleteCalender, deleteCalenderLeaves, updateCalender } from "../../../redux/calender/action";
import { titlevalidation } from "../../Common/commonvalidation";

const validationSchema = Yup.object({
  title: titlevalidation,
  start_date: Yup.date().required("Start date is required"),
  end_date: Yup.date()
    .required("End date is required")
    .min(Yup.ref("start_date"), "End date cannot be before the start date"),
});


export default function CalendarModel({ date, setModel, data, apihit }) {

  const initialValues = {
    title: data?.model_title || "",
    start_date: data?.start_date || "",
    end_date: data?.end_date || "",
  };

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    setLoading(true);
    if (data?.model_id) {
      const data1 = {
        ...values,
        "type": "1",
        'id': data?.model_id,
        'date': date
      }
      dispatch(updateCalender(data1));
      setModel(false);
    }
    else {
      const data1 = {
        ...values,
        "type": "1",
        'date': date
      }
      dispatch(addCalender(data1));
      setModel(false);
    }
    setModel(false);
    setLoading(false);
  };


  const deleteUnavailableDay = () => {
    dispatch(deleteCalenderLeaves(data?.model_id));
    setModel(false);
  }
  return (
    <>
      <div className="add-task">
        <h6>{data?.model_id ? "Edit" : "Add"} unavailable days</h6>
        <button
          onClick={() => setModel(false)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
      </div>

      {/* Formik wrapper */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleBlur, touched, errors }) => (
          <Form>
            <ModalBody>
              <div className="form-group">
                <label className="label">Reason for Unavailability *</label>
                <Field
                  type="text"
                  name="title"
                  className="form-control"
                  placeholder="Enter here"
                />
                {touched.title && errors.title && (
                  <div style={{ color: "red" }}>{errors.title}</div>
                )}
              </div>

              <div className="form-group">
                <label className="label">Start Date *</label>
                <Field
                  type="date"
                  name="start_date"
                  className="form-control"
                  placeholder="Select start date"
                />
                {touched.start_date && errors.start_date && (
                  <div style={{ color: "red" }}>{errors.start_date}</div>
                )}
              </div>

              <div className="form-group">
                <label className="label">End Date *</label>
                <Field
                  type="date"
                  name="end_date"
                  className="form-control"
                  placeholder="Select end date"
                />
                {touched.end_date && errors.end_date && (
                  <div style={{ color: "red" }}>{errors.end_date}</div>
                )}
              </div>
            </ModalBody>

            <ModalFooter>
              <Button
                disabled={loading}
                type="submit"
                className="btn"
              >
                {loading ? <LoginLoaderButton /> : `${data?.model_id ? "Update" : "Add"}`}
              </Button>
              {data?.model_id &&
                <>
                  <br></br>
                  <Button
                    className="btn"
                    onClick={() => { deleteUnavailableDay() }}
                    style={{ background: 'red' }}
                  >
                    {loading ? <LoginLoaderButton /> : `Delete`}
                  </Button>
                </>
              }
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </>
  );
}
